import type { BreadcrumbsCategory } from "~/types/composables/useCategoryTypes";

/**
 * Breadcrumbs read only `Name` and the `Parent` chain. The tree node also
 * carries its whole `Children` subtree plus description, synonyms and
 * parametrics, which would ride in the SSR payload of every PDP (snapshot +
 * pageStore) and category page for nothing. Blanked rather than omitted so
 * the shape stays a `BreadcrumbsCategory` for the store and templates that
 * read it.
 */
export const toBreadcrumbChain = (
	category: BreadcrumbsCategory
): BreadcrumbsCategory => ({
	...category,
	Children: null,
	Description: "",
	Synonyms: "",
	Parametrics: []
});
